// Library for abstracting out pagination strategies.
import qs from 'qs';

export function calculatePage(url, nextPage) {
  return nextPage || url;
}

export function parsePageNum(url) {
  // Parse out the page number so we can store it.
  let pageNum = 1;
  if (url.indexOf('?') > 0) {
    const queryString = url.substring(url.indexOf('?'));
    const pageQuery =
      queryString && qs.parse(queryString, { ignoreQueryPrefix: true }).page;
    pageNum = parseInt(pageQuery || 1, 10);
  }
  return pageNum;
}

export function handlePageData(stateData, url, pageData) {
  const pageNum = parsePageNum(url);
  return {
    ...stateData,
    [pageNum]: {
      url: url,
      entries: pageData.data,
      nextPage: pageData.next_page_url,
    },
  };
}

export function selectPageData(stateData) {
  let page = null;
  let nextPage = null;
  let data = [];
  let pages = [];
  let hasResults = false;
  for (let pageNum = 1; pageNum; pageNum++) {
    if (!(page = stateData[pageNum])) {
      break;
    }
    data.push(...page.entries);
    pages.push(page.url);
    nextPage = page.nextPage;
    hasResults = true;
  }
  return {
    data,
    nextPage,
    pages,
    hasResults,
  };
}
